export const SET_CALENDAR_MANAGEMENT = "SET_CALENDAR_MANAGEMENT";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_CALENDAR_FOUND = "SET_CALENDAR_FOUND";
export const SET_CREDENTIALS_KEY = "SET_CREDENTIALS_KEY";
export const UPDATE_CALENDAR_INFO = "UPDATE_CALENDAR_INFO";
export const UPDATE_SCHEDULING_WINDOWS = "UPDATE_SCHEDULING_WINDOWS";
export const UPDATE_IS_SAME_AS_OPENING_HOURS = "UPDATE_IS_SAME_AS_OPENING_HOURS";
export const UPDATE_APPOINTMENT_TYPES = "UPDATE_APPOINTMENT_TYPES";
export const UPDATE_OPEN_APPOINTMENT_TYPES = "UPDATE_OPEN_APPOINTMENT_TYPES";
export const UPDATE_APPOINTMENT_TYPE_ERRORS = "UPDATE_APPOINTMENT_TYPE_ERRORS";
export const setCalendarManagement = (calendarManagement) => ({
  type: SET_CALENDAR_MANAGEMENT,
  payload: calendarManagement,
});

export const setUserInfo = (userInfo) => ({
  type: SET_USER_INFO,
  payload: userInfo,
});

export const setCalendarFound = (calendarFound) => ({
  type: SET_CALENDAR_FOUND,
  payload: calendarFound,
});

export const setCredentialsKey = (credentialsKey) => ({
  type: SET_CREDENTIALS_KEY,
  payload: credentialsKey,
});

export const updateCalendarInfo = (calendarInfo) => ({
  type: UPDATE_CALENDAR_INFO,
  payload: calendarInfo,
});

export const updateSchedulingWindows = (schedulingWindows) => ({
  type: UPDATE_SCHEDULING_WINDOWS,
  payload: schedulingWindows,
});

export const updateIsSameAsOpeningHours = (isSameAsOpeningHours) => ({
  type: UPDATE_IS_SAME_AS_OPENING_HOURS,
  payload: isSameAsOpeningHours,
});

export const updateAppointmentTypes = (appointmentTypes) => ({
  type: UPDATE_APPOINTMENT_TYPES,
  payload: appointmentTypes,
});

export const updateOpenAppointmentTypes = (openAppointmentTypes) => ({
  type: UPDATE_OPEN_APPOINTMENT_TYPES,
  payload: openAppointmentTypes,
});

export const updateAppointmentTypeErrors = (appointmentTypeErrors) => ({
  type: UPDATE_APPOINTMENT_TYPE_ERRORS,
  payload: appointmentTypeErrors,
});
